<div class="bodycontent">

    <div class="subheader with-padding flgrow">
        <div class="row">

            <!-- Dealer Selection -->
            <div class="col-lg-2 col-md-3 col-sm-6" *ngIf="dealers && dealers?.length > 0">
                <div class="input-group">
                    <ng-select class="w-100" [class.is-invalid]="isDealerRequired"
                        placeholder="{{ 'lblSelectDealer' | translate }}" [(ngModel)]="dealerId" name="dealerId"
                        (change)="onDealerChange($event)">
                        <ng-option *ngFor="let dealer of dealers" [value]="dealer.dealerId">
                            {{dealer.name}}
                        </ng-option>
                    </ng-select>
                </div>
                <div *ngIf="isDealerRequired" class="invalid-feedback d-block">
                    <small class="text-danger" translate>lblRequiredDealer</small>
                </div>
            </div>

            <!-- Mechanic Selection -->
            <div class="col-lg-2 col-md-3 col-sm-6">
                <div class="input-group">
                    <ng-select class="w-100" [class.is-invalid]="isMechanicRequired"
                        placeholder="{{ 'lblSelectMechanic' | translate }}" [(ngModel)]="mechanicId" name="mechanicId"
                        (change)="onSelectMechanic($event)" [disabled]="!dealerId || mechanicList.length === 0">
                        <ng-option *ngFor="let mechanic of mechanicList" [value]="mechanic.id">
                            {{mechanic.name}}
                        </ng-option>
                    </ng-select>
                </div>
                <div *ngIf="isMechanicRequired" class="invalid-feedback d-block">
                    <small class="text-danger" translate>lblRequiredMechanic</small>
                </div>
            </div>

            <!-- Date Range Selection -->
            <div class="col-lg-2 col-md-3 col-sm-6">
                <div class="date">
                    <input bsDaterangepicker name="StampInDate" [bsConfig]="myDateRangePickerOptions"
                        class="form-control" [(ngModel)]="stampInDate" (ngModelChange)="onDateRangeChanged($event)"
                        placeholder="Select Date Range" />
                </div>
            </div>

            <div class="col-lg-2 col-md-3 col-sm-6 pl-4" *ngIf="dealerList && dealerList.length > 0;">
                <div class="d-flex align-items-center">
                    <!-- Search Button -->
                    <button type="button" (click)="onSearchReport()" class="btn btn-primary btn-md mr-2"
                        [disabled]="!dealerId || !mechanicId || !stampInDate || stampInDate.length < 2"
                        ngbTooltip="{{'lblSearch' | translate}}" placement="bottom">
                        <em class="fa fa-search"></em>
                    </button>
                    <!-- Refresh Button -->
                    <button type="button" class="btn btn-outline-primary btn-md mr-2" (click)="refresh()"
                        [disabled]="!isSearched" ngbTooltip="{{'lblRefresh' | translate}}" placement="bottom"
                        aria-label="Center Align">
                        <em class="fas fa-sync fa-lg"></em>
                    </button>
                    <!-- Reset Button -->
                    <button type="button" (click)="onReset()" class="btn btn-primary btn-md"
                        ngbTooltip="{{ 'lblClearFilters' | translate }}" placement="bottom" aria-label="Center Align">
                        <em class="far fa-times-circle font16 align-top"></em>
                    </button>
                </div>
            </div>

            <!-- Export Buttons -->
            <div
                class="col-xl-2 col-md-3 col-lg-1 d-flex align-items-center flex-sm-row flex-column justify-content-end ml-auto">
                <div class="d-flex align-items-center">
                    <button type="button" (click)="exportAsXLSX()" ngbTooltip="{{'lblExportExcel' | translate}}"
                        placement="left" aria-label="Center Align" class="mr-2">
                        <img src="./../../../assets/images/excel.png" height="32" width="32" alt="Excel" />
                    </button>
                    <button class="btn btn-link icon-pdf" type="button" (click)="exportAsPDF()"
                        ngbTooltip="{{'lblExportPDF' | translate}}" placement="left" aria-label="Center Align">
                        <em class="far fa-file fa-2x"></em>
                        <span class="bdg">PDF</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="container prel" *ngIf="isMechanicSelected">
        <div class="row">
            <div class="c12">
                <div class="card mb-3">
                    <!-- Body Header -->
                    <div class="card-header d-flex justify-content-between" translate>
                        lblWorkOrderTimeStampReport
                        <div class="font16 fontbold">
                            <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;
                            {{ totalCount }}
                            &nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                        </div>
                    </div>

                    <!-- Body Content -->
                    <div class="table-responsive max-h254" infinite-scroll [infiniteScrollDistance]="scrollDistance"
                        [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown()">
                        <table class="tablest1" id="timeStampPdf">
                            <thead>
                                <tr>
                                    <th style="width: 55px" scope="col">#</th>
                                    <th scope="col" class="text-left" translate>lblMechanicNumber</th>
                                    <th scope="col" class="text-left" translate>lblMechanicName</th>
                                    <th scope="col" sortable="orderNo" class="text-left" translate
                                        (sort)="onSort($event)">
                                        lblWoNo
                                    </th>
                                    <th scope="col" class="text-left" translate> lblJob</th>
                                    <th scope="col" sortable="punchDate" class="text-center" translate
                                        (sort)="onSort($event)">
                                        lblPunchDate
                                    </th>
                                    <th scope="col" class="text-right" translate>lblStartTime</th>
                                    <th scope="col" class="text-right" translate>lblEndTime</th>
                                    <th scope="col" class="text-center" translate>lblMissedPunch</th>
                                    <th scope="col" class="text-right" translate>lblStandardTime</th>
                                    <th scope="col" class="text-right" translate>lblTimeConsumed</th>


                                </tr>
                            </thead>

                            <tbody>
                                <ng-container *ngIf="timeStampList?.length > 0; else load_NotFound_Template">
                                    <tr *ngFor="let item of timeStampList; let i = index">
                                        <td class="click">{{ i + 1 }}</td>
                                        <td class="text-left">
                                            <div>{{ item.employeeNo }}</div>
                                        </td>
                                        <td class="text-left">
                                            <div>{{ item.mechanicName }}</div>
                                        </td>
                                        <td class="text-left">
                                            <div>{{ item.orderNo }}</div>
                                        </td>
                                        <td class="text-left">
                                            <div>{{ item.demandNo }}- {{item.description }}</div>
                                        </td>
                                        <td class="text-center">
                                            <div>{{ item.punchDate | date : 'shortDate'}}</div>
                                        </td>
                                        <td class="text-right">
                                            <div>{{ item.startTime | date:'HH:mm:ss' }}</div>
                                        </td>
                                        <td class="text-right">
                                            <div *ngIf="item.endTime">
                                                {{ item.endTime | date:'HH:mm:ss' }}
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <div>{{ item.missedPunch }}</div>
                                        </td>
                                        <td class="text-right">
                                            <div>{{item.workTime }}</div>
                                        </td>
                                        <td class="text-right">
                                            <div>{{ item.timeUsed }}</div>
                                        </td>
                                    </tr>
                                </ng-container>

                                <ng-template #load_NotFound_Template>
                                    <tr>
                                        <td colspan="11" class="no-record" translate>
                                            lblNoRecordsFound
                                        </td>
                                    </tr>
                                </ng-template>
                            </tbody>

                        </table>
                    </div>
                    <div class="card-footer" *ngIf="timeStampList?.length > 0">
                        <div class="mb-2">
                            <strong translate>lblTotalWorkTime</strong>: {{ getTotalWorkTimeFormatted() }}
                        </div>
                        <div class="mb-2">
                            <strong translate>lblTotalConsumedTime</strong>: {{ getTotalTimeUsedFormatted() }}
                        </div>
                        <div>
                            <strong translate>lblEfficiencyTitle</strong>: {{ getEfficiencyPercent() }}%
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>